import styled from 'styled-components';

export const SBannerContent = styled.p`
  margin-bottom: 0;
`;
